import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import TextField from "../../../1. Core/Controls/TextField/TextField";
import NP from "../../../1. Core/NP";
import {getTournaments, ITournament} from "../../Util";
import {
	EventTournament,
	FighterCompareStatWidgetMetadata, IBattle,
	SportType,
	Widget
} from "../../types";
import {ServerAPI} from "../../../1. Core/ServerAPI";
import {WidgetType} from "../WEnum";
import SelectFighterCtrl from "../../../2. Athletes/SelectFighterCtrl";
import Select from "../../../1. Core/Controls/Select/Select";
import ColorPicker from "../../../1. Core/Controls/ColorPicker/ColorPicker";


export default class FighterCompareStatWidgetEditDialog extends Dialog {
	private _name: TextField;

	private _backgoundUrlInput: TextField;

	private _eventCombo: Select;
	private _tournamentCombo: Select;

	private _Widget: Widget<FighterCompareStatWidgetMetadata>;

	private _previewFrame: HTMLFrameElement;
	private _timeId: any;

	private _leftTopLogoUrlInput: TextField;
	private _logoRightBottomLogoUrlInput: TextField;
	private _redPhotoUrlInput: TextField;
	private _bluePhotoUrlInput: TextField;
	private _title1: TextField;
	private _title2: TextField;
	private _title3: TextField;
	private _selectRedFighter: SelectFighterCtrl;
	private _selectBlueFighter: SelectFighterCtrl;
	private _periodType: Select;
	private _fontCombo: Select;
	private _fontColor: ColorPicker;
	private fromYear: Select;
	private toYear: Select;
	private _Battle: IBattle;


	_initFields(settings: object)
	{
		this._Battle = null;
		this._Widget = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('FighterCompareStatWidget');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
		this._AutoDestroy = true;
		this._Width = 1700;
	}

	_render()
	{
		super._render();

		let flexNode = NP.createNode(this._contentNode, 'widget-dlg-content-node')
		let leftNode = NP.createNode(flexNode, 'widget-dlg-settings-node')
		this._contentDomNode.style.maxWidth = '1700px'

		this._name = new TextField({
			FloatingLabel: NP.RM.getString('Name'),
			ParentNode: leftNode
		});

		this._selectRedFighter = new SelectFighterCtrl({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('Red'),
			EvSelected: () => this.onSettingsChanged()
		})

		this._redPhotoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('PhotoUrl'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._selectBlueFighter = new SelectFighterCtrl({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('Blue'),
			EvSelected: () => this.onSettingsChanged()
		})

		this._bluePhotoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('PhotoUrl'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});


		this._title1 = new TextField({
			FloatingLabel: "Title 1",
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._title2 = new TextField({
			FloatingLabel: "Title 2",
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._title3 = new TextField({
			FloatingLabel: "Title 3",
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._periodType = new Select({
			FloatingLabel: NP.RM.getString('PeriodType'),
			ParentNode: leftNode,
			Items: [
				{RK: 'All', Value: 'All'},
				{RK: 'Period', Value: 'Period'},
				{RK: 'Event', Value: 'Event'}
			],
			Value: 'All',
			EvItemSelected: () =>
			{
				switch (this._periodType.getValue())
				{
					case 'Period':
						this.fromYear.setIsVisible(true);
						this.toYear.setIsVisible(true);
						this._tournamentCombo.setIsVisible(false);
						this._eventCombo.setIsVisible(false)
						break;
					case 'All':
						this.fromYear.setIsVisible(false);
						this.toYear.setIsVisible(false);
						this._tournamentCombo.setIsVisible(false);
						this._eventCombo.setIsVisible(false)
						break;
					case 'Event':
						this.fromYear.setIsVisible(false);
						this.toYear.setIsVisible(false);
						this._tournamentCombo.setIsVisible(true);
						this._eventCombo.setIsVisible(true)
						break
				}

				this.onSettingsChanged();
			}
		})

		this.fromYear = new Select({
			ParentNode: leftNode,
			EvItemSelected: () => this.onSettingsChanged(),
			Items: this.createYearsArray()
		});

		this.toYear = new Select({
			ParentNode: leftNode,
			EvItemSelected: () => this.onSettingsChanged(),
			Items: this.createYearsArray()
		});

		this._tournamentCombo = new Select({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('Tournament'),
			EvItemSelected: () => this.updateEvents()
		});

		this._eventCombo = new Select({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('Event'),
			EvItemSelected: () => this.onSettingsChanged()
		});


		this._backgoundUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('Background'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._fontCombo = new Select({
			ParentNode: leftNode,
			Value: 'Muller',
			Items: [
				{Content: 'Muller', Value: 'Muller'},
				{Content: 'Roboto', Value: 'Roboto'},
				{Content: 'Corbert', Value: 'Corbert'},
				{Content: 'Bourgeois', Value: 'Bourgeois'},
				{Content: 'Swis', Value: 'Swis721 Blk BT'},
				{Content: 'PF Din Text Comp Pro', Value: 'PF Din Text Comp Pro'}
			],
			FloatingLabel: NP.RM.getString('FontFamily'),
			EvItemSelected: () => this.onSettingsChanged()
		});

		this._fontColor = new ColorPicker({
			ParentNode: leftNode,
			FloatingLabel: NP.RM.getString('FontColor'),
			EvColorChanged: () => this.onSettingsChanged()
		})


		this._leftTopLogoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('LeftLogo'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._logoRightBottomLogoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('RightLogo'),
			ParentNode: leftNode,
			EvChanging: () => this.onSettingsChanged()
		});


		this._previewFrame = NP.createNode(flexNode, '', 'iframe');

		if (this._Widget)
		{
			this._selectRedFighter.setValue(this._Widget.Metadata.RedId)
			this._selectBlueFighter.setValue(this._Widget.Metadata.BlueId)

			this._redPhotoUrlInput.setValue(this._Widget.Metadata.RedPhotoUrl)
			this._bluePhotoUrlInput.setValue(this._Widget.Metadata.BluePhotoUrl)

			this._name.setValue(this._Widget.Name)
			this._title1.setValue(this._Widget.Metadata.Title1)
			this._title2.setValue(this._Widget.Metadata.Title2)
			this._title3.setValue(this._Widget.Metadata.Title3)

			this._backgoundUrlInput.setValue(this._Widget.Metadata.Background)

			this._leftTopLogoUrlInput.setValue(this._Widget.Metadata.LeftLogo)
			this._logoRightBottomLogoUrlInput.setValue(this._Widget.Metadata.RightLogo);
			this._fontColor.setValue(this._Widget.Metadata.FontColor || 'black')

			this._fontCombo.setValue(this._Widget.Metadata.FontFamily || 'Muller')

			if (this._Widget.Metadata.PeriodType == 'Period')
			{
				this._periodType.setValue('Period')
				this.fromYear.setValue(this._Widget.Metadata.FromYear);
				this.toYear.setValue(this._Widget.Metadata.ToYear);
			}
			else if (this._Widget.Metadata.EventId)
			{
				this._periodType.setValue('Event')
			}
			else
			{
				this._periodType.setValue('All')
			}
		}
		else
			this._periodType.setValue('All')


		if (!this._Widget)
		{
			this._Widget = {
				Metadata: {WId: WidgetType.FighterCompareStat}
			} as Widget<FighterCompareStatWidgetMetadata>

			if (this._Battle)
			{
				this._selectRedFighter.setValue(this._Battle.Red)
				this._selectBlueFighter.setValue(this._Battle.Blue)

 				let year =  new Date().getFullYear()
				this._periodType.setValue('Period')
				this.fromYear.setValue(year - 1);
				this.toYear.setValue(year);

				this._backgoundUrlInput.setValue('#000000')
				this._fontColor.setValue('#ffffff')

				this._title1.setValue(this._Battle.EventInfo)
				this._title2.setValue(this._Battle.RedName + ' vs ' + this._Battle.BlueName)
				this._title3.setValue("Last 2 years STATS")

				this._name.setValue(this._Battle.RedName + ' vs ' + this._Battle.BlueName)
			}
		}
		this.refresh()
	}

	createYearsArray()
	{
		let startYear = 1990;
		let arr = [];
		let cYear = new Date().getFullYear();

		for (let y = startYear; y <= cYear; y++)
		{
			arr.push({
				Content: y,
				Value: y
			})
		}
		return arr;
	}

	onSettingsChanged()
	{
		if (this._timeId)
			clearTimeout(this._timeId);

		this._timeId = setTimeout(() => this.updatePreview(), 200);
	}

	updateObjSettings()
	{
		this._Widget.Name = this._name.getValue()
		this._Widget.Metadata.RedId = this._selectRedFighter.getValue();
		this._Widget.Metadata.BlueId = this._selectBlueFighter.getValue();
		this._Widget.Metadata.RedPhotoUrl = this._redPhotoUrlInput.getValue()
		this._Widget.Metadata.BluePhotoUrl = this._bluePhotoUrlInput.getValue()

		this._Widget.Metadata.Title1 = this._title1.getValue();
		this._Widget.Metadata.Title2 = this._title2.getValue();
		this._Widget.Metadata.Title3 = this._title3.getValue();

		this._Widget.Metadata.Background = this._backgoundUrlInput.getValue()
		this._Widget.Metadata.LeftLogo = this._leftTopLogoUrlInput.getValue()
		this._Widget.Metadata.RightLogo = this._logoRightBottomLogoUrlInput.getValue()
		this._Widget.Metadata.FontFamily = this._fontCombo.getValue()


		this._Widget.Metadata.FontColor = this._fontColor.getValue()

		switch (this._periodType.getValue())
		{
			case 'Period':
				this._Widget.Metadata.FromYear = this.fromYear.getValue()
				this._Widget.Metadata.ToYear = this.toYear.getValue()
				this._Widget.Metadata.PeriodType = "Period";
				this._Widget.Metadata.EventId = null;
				break;
			case 'All':
				this._Widget.Metadata.EventId = null;
				this._Widget.Metadata.FromYear = null;
				this._Widget.Metadata.ToYear = null;
				this._Widget.Metadata.PeriodType = "";
				break;
			case 'Event':
				this._Widget.Metadata.FromYear = null;
				this._Widget.Metadata.ToYear = null;
				this._Widget.Metadata.PeriodType = "";
				this._Widget.Metadata.EventId = this._eventCombo.getValue();
				break
		}
	}

	updatePreview()
	{
		this.updateObjSettings();

		if (this._Widget.Metadata.RedId && this._Widget.Metadata.BlueId)
			this._previewFrame.src = `/cwidget/fighter-compare-stat?id=${this._Widget.Id || -1}&lang=${NP.getCurrentCulture().Name}&json=${encodeURIComponent(JSON.stringify(this._Widget))}`
	}

	async refresh()
	{

		let tList = await getTournaments(SportType.MMA) as ITournament[]


		let items = tList.map(t => ({Value: t.Id, FontImage: NP.FontImages.integration, Content: t.Name, Data: t}));
		this._tournamentCombo.setItems(items);


		if (this._Widget && this._Widget.Metadata.EventId)
		{
			let ev = await ServerAPI.get<EventTournament>(`/t-events/${this._Widget.Metadata.EventId}`)
			if (ev)
			{
				this._tournamentCombo.setValue(ev.TournamentId)
				await this.updateEvents(ev.TournamentId);
				this._eventCombo.setValue(this._Widget.Metadata.EventId, false);
				this.updatePreview()
			}
		}
		else
		{
			if (tList[0])
			{
				this._tournamentCombo.setValue(tList[0].Id)
				this.updateEvents();
			}
		}
	}

	async updateEvents(tId: number = null)
	{
		let response = await ServerAPI.post("/t-events", {
			Count: 500,
			Offset: 0,
			TournamentId: tId || this._tournamentCombo.getValue()
		}) as { List: EventTournament[], AllCount: number };
		this._eventCombo.setItems(response.List.map(ev => ({Content: ev.Name, Value: ev.Id})));
	}


	async _onOkButtonClick()
	{
		this.updateObjSettings();

		if (this._Widget.Id)
			await ServerAPI.callUiApi(`/widget/${this._Widget.Id}`, this._Widget, 'POST');
		else
			await ServerAPI.callUiApi("/widget", this._Widget, 'PUT')


		this.EvOkButtonClick.fire(this);
		this.hide();
	}
}